define('mediator',['require','underscore','backbone','chaplin','models/user-settings','models/current-user','lib/utils','config/application','bcsocket','lib/channel','config/application','config/environment'],function(require) {

    'use strict';

    var _ = require('underscore'),
        Backbone = require('backbone'),
        Chaplin = require('chaplin'),
        UserSettings = require('models/user-settings'),
        CurrentUser = require('models/current-user'),
        utils = require('lib/utils'),
        configApplication = require('config/application');

    var mediator = Chaplin.mediator;

    _.extend(mediator, {

        removeUser: function() {
            window.localStorage.removeItem('accessToken');

            this.closeChannel();

            this.user.dispose();
            this.user = null;

            mediator.setupAuthorization(configApplication.apiKey);

            this.publish('signinStatus', false);
        },

        setupAuthorization: function(accessToken) {
            Backbone.$.ajaxSetup({
                headers: { 'Authorization': ['Bearer', accessToken].join(' ') }
            });
        },

        openChannel: function(accessToken) {
            var BCSocket = require('bcsocket'),
                Channel = require('lib/channel'),
                applicationConfig = require('config/application'),
                environmentConfig = require('config/environment');

            this.closeChannel();

            this.channel = new Channel(new BCSocket(environmentConfig[applicationConfig.environment].api.root + '/channel', {
                reconnect: true,
                affinityParam: 'access_token',
                affinity: accessToken
            }));
        },

        closeChannel: function() {
            if (this.channel) {
                this.channel.close();
                this.channel = null;
            }
        },

        isAuthorized: function() {
            return this.user && this.user.get('accessToken');
        },

        isDemo: function() {
            return this.isAuthorized() && this.user.get('_demo');
        },

        signin: function(accessToken) {
            var _this = this;

            var user = this.user;

            if (!user) {
                user = new CurrentUser();
                user.on('change:accessToken', function(model, value) {
                    window.localStorage.setItem('accessToken', value);

                    mediator.setupAuthorization(value);

                    if (value) {
                        _this.openChannel(value);
                    } else {
                        _this.closeChannel();
                    }
                });
                this.user = user;
            }

            var userSettings = this.userSettings;

            if (!userSettings) {
                userSettings = new UserSettings();
                this.userSettings = userSettings;
            }

            user.set({ accessToken: accessToken });

            return user
                .fetch()
                .done(function() {

                    userSettings.fetch();

                    var isDemo = user.get('_email') === 'florexdemo@gmail.com';

                    _this.poll.set('visible', false);

                    _this.publish('signinStatus', true);
                })

                .fail(_.bind(this.removeUser, this));
        },

        signout: function() {
            if (!this.user) { return; }

            this.user.destroy();
            this.removeUser();
        },

        setBreadcrumb: function(parents, tailText) {
            var result = [];
            _.each(parents, function(name) {
                var pageName, obj;
                if(typeof name !== 'string'){
                    pageName = name.name;
                    obj = name;
                } else {
                    pageName = name;
                    obj = null;
                }
                var page = Chaplin.mediator.pages.where({ name: pageName })[0];
                if (page) {
                    var item = page.getAttributes();
                    item.isLast = false;
                    var _item = obj ?  _.extend(_.cloneDeep(item), obj): item;
                    result.push(_item);
                }
            });

            if (tailText) {
                result.push({
                    title: tailText,
                    action: '',
                    isLast: true
                });
            }

            this.breadcrumb.set('items', result);
        },

        setBreadcrumbTail: function(name) {
            this.setBreadcrumb(_.pluck(this.breadcrumb.get('items'), 'name'), name);
        }

    });

    mediator.setupAuthorization(configApplication.apiKey);

    return mediator;
});
